import { ContentTypeEnum } from "@/static/dataType";

const data = {
  support: {
    title: "動作環境",
    headers: ["対象", "環境", "ブラウザ"],
    data: [
      {
        title: "PC",
        text: "Windows 10/11<br/>macOS v10.12以上",
        text2:
          "Google Chrome(最新版)<br/>Mozilla Firefox(最新版)<br/>Safari(最新版)<br/>Microsoft Edge(Chromium最新版)",
      },
      {
        title: "Android",
        text: "Android(最新版)",
        text2: "Android Chrome(最新版)",
      },
      {
        title: "iOS",
        text: "iOS(最新版)<br/>iPadOS(最新版)<br/>※iOS 17.1未満は動作しません",
        text2: "Safari(最新版)",
      },
    ],
  },
  production: {
    title: "機能制約",
    headers: ["SDK(JavaScript)動作", "制限値"],
    data: [
      {
        type: ContentTypeEnum.api,
        title: "初期化",
        text: "制限なし",
      },
      {
        type: ContentTypeEnum.api,
        title: "アクセストークン設定",
        text: "制限なし<br/>アクセストークンの取得はSafie APIの機能制限に従います。",
      },
      {
        type: ContentTypeEnum.api,
        title: "アクセストークン削除",
        text: "制限なし",
      },
      {
        type: ContentTypeEnum.api,
        title: "画像取得",
        text: "500 req / 1 min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "デバイス一覧取得",
        text: "300 req / 1 min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "メディア一覧取得",
        text: "500 req / 1 min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "位置情報取得",
        text: "10 req / 1 min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "標準イベント一覧取得",
        text: "500 req / 1 min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "サムネイル取得",
        text: "500 req / 1min / アプリケーション & デバイス<br/>画素数：機種と設定によります。<br/>アスペクト比：機種と設定によります。",
      },
      {
        type: ContentTypeEnum.api,
        title: "スチルキャプチャ",
        text: "15 req / 15 min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "ストリーミングプレイヤー",
        text: "同時配置数: 6 Player / ページ<br/>プラン：トライアルとプラン：プロダクトは別枠の扱いとなり、それぞれで利用できます。ただし、プラン：トライアルでは、Safie APIのHTTP Live Streamingプレイリスト取得との共通枠となります。<br/>アクセスできるアプリケーション数はオプションごとに異なります。",
      },
      {
        type: ContentTypeEnum.api,
        title: "ユーザ情報取得",
        text: "300 req / 1 min / アプリケーション<br/>Safie APIのユーザ情報取得と共用の制限となります。",
      },
    ],
  },
  trial: {
    title: "トライアルプランでの使用上限",
    headers: ["SDK(JavaScript)動作", "上限値 / 月 / デバイス"],
    data: [
      {
        type: ContentTypeEnum.api,
        title: "画像取得",
        text: "5万枚",
      },
      {
        type: ContentTypeEnum.api,
        title: "ストリーミングプレイヤー",
        text: "240時間（10日分）<br/>Safie APIのHTTP Live Streamingプレイリスト取得と共用の制限となります。",
      },
      {
        type: ContentTypeEnum.api,
        title: "その他機能",
        text: "制限なし",
      },
    ],
    tip: "*1 *2 の合計が最大5万枚/月となります。",
  },
  chooseList: {
    title: "オプション名一覧",
    headers: ["item_id", "オプション名", "内容"],
    data: [
      {
        title: "948",
        text: "静止画 API（10万枚）",
        text2: "Devices/画像取得　10万枚 / 月",
      },
      {
        title: "949",
        text: "静止画 API（50万枚）",
        text2: "Devices/画像取得　50万枚 / 月",
      },
      {
        title: "950",
        text: "静止画 API（100万枚）",
        text2: "Devices/画像取得　100万枚 / 月",
      },
      {
        title: "951",
        text: "静止画 API（200万枚）",
        text2: "Devices/画像取得　200万枚 / 月",
      },
      {
        title: "959",
        text: "スチルキャプチャ API",
        text2: "Devices/スチルキャプチャ　制限なし",
      },
      {
        title: "973",
        text: "位置情報取得 API",
        text2: "Devices/位置情報取得　制限なし",
      },
      {
        title: "1050",
        text: "基本機能 API",
        text2:
          "Devices/デバイス一覧取得　制限なし<br />Devices/メディア一覧取得　制限なし<br />Devices/サムネイル取得　制限なし<br />Devices/標準イベント一覧取得　制限なし<br />※基本機能APIオプション以外が付与されている場合も、これらの機能は利用できます",
      },
      {
        title: "1107",
        text: "ストリーミング SDK",
        text2:
          "Player 4,096時間 / 月<br />アクセス: 1 アプリケーション / 月 / デバイス",
      },
      {
        title: "1150",
        text: "ストリーミング SDK（100ユーザー）",
        text2:
          "Player 25,600時間 / 月<br />アクセス: 1 アプリケーション / 月 / デバイス",
      },
      {
        title: "1437",
        text: "ストリーミング SDK（2アプリケーション）",
        text2:
          "Player 8,192時間 / 月<br />アクセス: 2 アプリケーション / 月 / デバイス",
      },
    ],
  },
};

const context = {
  headerTitle: "SDK 機能制約",
  headerIcon: require("./images/header-icon.svg"),
  data,
};
export default context;
